import { CampaignFormCustomer } from '@features/Admin/Campaign/model/type';

export const removeDuplicatePhones = (data: CampaignFormCustomer[]): CampaignFormCustomer[] => {
  const globalUniquePhones = new Set<string>();

  return data.reduce<CampaignFormCustomer[]>(
    (acc: CampaignFormCustomer[], item: CampaignFormCustomer) => {
      const phone = item.number;
      if (phone && !globalUniquePhones.has(phone)) {
        globalUniquePhones.add(phone);
        acc.push(item);
      }

      return acc;
    },
    [],
  );
};
